import React from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';
import ReadOnlyField from '../../../components/readOnlyField/ReadOnlyField';

const STATUS_OPTIONS = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' },
];

export default function UserEditModal({
  open,
  onCancel,
  form,
  onSubmit,
  submitLoading,
  roleOptions,
}) {
  return (
    <Modal
      title="Edit user"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="ok"
          type="primary"
          onClick={onSubmit}
          loading={submitLoading}
          className="app-btn-primary"
        >
          Save changes
        </Button>,
        <Button key="cancel" onClick={onCancel} className="app-btn-cancel">
          Cancel
        </Button>,
      ]}
      destroyOnClose
      width={420}
      className="user-list-modal"
    >
      <Form form={form} layout="vertical" className="user-list-form-in-modal">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Required' }]}
        >
          <Input placeholder="Full name" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Required' },
            { type: 'email', message: 'Invalid email' },
          ]}
        >
          <ReadOnlyField placeholder="email@example.com" />
        </Form.Item>
        <Form.Item name="roles" label="Roles">
          <Select
            mode="multiple"
            placeholder="Select roles"
            options={roleOptions}
            allowClear
          />
        </Form.Item>
        <Form.Item name="status" label="Status">
          <Select
            placeholder="Status"
            options={STATUS_OPTIONS}
            allowClear={false}
          />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="New password (optional)"
          rules={[
            { min: 6, message: 'At least 6 characters' },
          ]}
        >
          <Input.Password placeholder="Leave blank to keep current" autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="Confirm new password"
          dependencies={['newPassword']}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                const newPwd = getFieldValue('newPassword');
                if (!newPwd || !newPwd.trim()) return Promise.resolve();
                if (!value || value === newPwd) return Promise.resolve();
                return Promise.reject(new Error('Passwords do not match'));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm if changing password" autoComplete="new-password" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
